import FallbackComponent from './FallbackComponent'
export default FallbackComponent
